let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("77pyi"), load("3TNOq"), load("eCgOQ"), load("ipTFT"), load("gQSWJ"), load("krOJz")]).then(() => parcelRequire('lMhQj'));